export default class Events {
  static searchQuery = "search-query";
  static emptySearchQuery = "empty-search-query";

}